module.exports = __webpack_public_path__ + "static/media/tangent3.8282ce96.jpg";